module.exports = __webpack_public_path__ + "static/instalaciones-lujo-ae29f22c8f87f6d91dc507e4a02fe241.jpg";